let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eYFe9")).then(() => parcelRequire('eMuwP'));